<!-- TransportOffersView.vue -->
<template>
  <div class="card-modern">
  
    <!-- HEADER -->
    <div class="d-flex align-items-start justify-content-between mb-3 flex-wrap gap-3">
      <div>
        <h2 class="card-title-modern">
          Monitoring Penawaran Harga Biaya Angkut
        </h2>
        <p class="card-desc-modern mb-0">
          Kelola dokumen penawaran harga biaya angkut.
        </p>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end gap-2 mb-3 flex-wrap">
      <div class="position-relative" style="width:170px">
        <i class="bi bi-search text-muted"
          style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 1;"></i>
        <input v-model="filters.search" class="form-control" placeholder="Cari"
          style="padding-left: 32px; border-radius: 8px;" @input="onSearchInput" />
      </div>
      <button class="button-modern" @click="goToAdd">+ Add Dokumen</button>
  
    </div>
  
    <!-- TABLE -->
    <div class="modern-table-wrapper">
  
      <table class="table-modern">
  
        <thead>
          <tr>
            <th></th>
            <th>Nama Perusahaan</th>
            <th>Contract Type</th>
            <th class="text-center">Aksi</th>
          </tr>
        </thead>
  
        <tbody>
  
          <tr v-if="loading">
            <td colspan="3" class="text-center py-4">
              <div class="spinner-border spinner-border-sm me-2"></div>
              Memuat data...
            </td>
          </tr>
  
          <tr v-else-if="transportOffers.length === 0">
            <td colspan="3" class="text-center py-4 text-muted">
              Tidak ada data
            </td>
          </tr>
  
          <tr v-else v-for="item in transportOffers" :key="item.id">
  
            <td class="text-center">
              <span class="file-dot"
                :class="(Number(item.has_file) === 1 || Number(item.file_count) > 0) ? 'file-dot--yes' : 'file-dot--no'"
                :title="(Number(item.has_file) === 1 || Number(item.file_count) > 0) ? 'Ada file' : 'Belum upload file'"></span>
            </td>
  
            <td>
              {{ item.mst_corporate_name }}
            </td>
  
            <td>
              {{ item.contract_type_name }}
            </td>
  
            <!-- ACTION -->
            <td class="text-center">
  
              <button class="btn-icon-hover icon-warning" @click="goToEdit(item.id)" title="Edit">
                <i class="bi bi-pencil"></i>
              </button>
  
              <button class="btn-icon-hover icon-primary" @click="goToDetail(item.id)" title="Detail">
                <i class="bi bi-eye"></i>
              </button>
  
            </td>
  
          </tr>
  
        </tbody>
  
      </table>
  
    </div>
  
    <!-- PAGINATION -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <small class="text-muted">
        Menampilkan {{ (page - 1) * perPage + 1 }} - {{ Math.min(page * perPage, total) }} dari {{ total }} data
      </small>
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">Rows per page</small>
        <select v-model.number="perPage" class="form-select form-select-sm" style="width: 70px;" @change="changePerPage">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="goToPage(page - 1)">‹</button>
            </li>
            <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
              :class="{ active: p === page, disabled: p === '...' }">
              <button class="page-link" @click="p !== '...' && goToPage(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="goToPage(page + 1)">›</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  
  </div>
</template>

<script>
import TransportOffersViewJs from "./TransportOffersView";

export default TransportOffersViewJs;
</script>